import { createFileRoute } from '@tanstack/react-router';

import { InvestigationDetailPage } from '@/components/Investigations/InvestigationDetailPage';

export const Route = createFileRoute('/$organizationName/investigations/$investigationId')({
  component: InvestigationDetailRoute,
});

function InvestigationDetailRoute() {
  const { investigationId } = Route.useParams();
  return <InvestigationDetailPage investigationId={investigationId} />;
}
